function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkIllUpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 365.432,
    height: 124.376,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1875.347 1995.853-38.481-477.214c-13.732-170.338-163.133-318.233-331.982-328.646-143.687-8.86-256.964 84.595-279.083 217.616 32.184-62.919 98.582-102.758 178.31-97.841 118.874 7.33 223.989 111.387 233.665 231.32l35.654 442.313-120.072-7.404 232.208 152.12 209.863-124.86-120.082-7.404",
    style: {
      fill: "#ff7f2a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.1333 .00257 .00257 -.1333 48.44 279.111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1220.307 1509.393 46.943 466.122 203.953 8.508-47.968-476.343c-5.76-57.2 36.045-102.057 92.896-99.685 12.808.534 25.368 3.44 37.147 8.265-40.415-42.461-95.81-70.584-154.3-73.024-100.483-4.192-176.379 68.748-178.67 166.157",
    style: {
      fill: "#c8ab37",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.1333 .00257 .00257 -.1333 48.44 279.111)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "750.896px",
      lineHeight: 1.25,
      fontFamily: "Candara",
      InkscapeFontSpecification: "'Candara, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 18.7725
    },
    x: 700.812,
    y: -1140.326,
    transform: "matrix(.12225 0 0 .14542 -89.125 267.913)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "750.896px",
      fontFamily: "Candara",
      InkscapeFontSpecification: "'Candara, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 18.7725
    },
    x: 700.812,
    y: -1140.326
  }, "SKILL")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "879.323px",
      lineHeight: 1.25,
      fontFamily: "Candara",
      InkscapeFontSpecification: "'Candara, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 21.9831
    },
    x: 2845.136,
    y: -1262.239,
    transform: "matrix(.13713 0 0 .12964 -89.125 267.913)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "879.323px",
      fontFamily: "Candara",
      InkscapeFontSpecification: "'Candara, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000",
      strokeWidth: 21.9831
    },
    x: 2845.136,
    y: -1262.239
  }, "P")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkIllUpLogo);
export default __webpack_public_path__ + "static/media/SKIllUpLogo.29f5934fcae05264d78166c0338dd405.svg";
export { ForwardRef as ReactComponent };